import _definePage_default_0 from 'D:/works/mango/kiosk-module/backoffice/src/features/auth/routes/login.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'

export const routes = [
  {
    path: '/activity',
    /* internal name: '/activity' */
    /* no component */
    children: [
      {
        path: '',
        name: '/activity/',
        component: () => import('D:/works/mango/kiosk-module/backoffice/src/features/activity/routes/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/auth',
    /* internal name: '/auth' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '/login',
          name: '/auth/login',
          component: () => import('D:/works/mango/kiosk-module/backoffice/src/features/auth/routes/login.vue'),
          /* no children */
        },
        _definePage_default_0
      )
    ],
  },
  {
    path: '/cage',
    /* internal name: '/cage' */
    /* no component */
    children: [
      {
        path: '',
        name: '/cage/',
        component: () => import('D:/works/mango/kiosk-module/backoffice/src/features/cage/routes/index.vue'),
        /* no children */
      },
      {
        path: 'exceptions',
        name: '/cage/exceptions',
        component: () => import('D:/works/mango/kiosk-module/backoffice/src/features/cage/routes/exceptions.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/day',
    /* internal name: '/day' */
    /* no component */
    children: [
      {
        path: '',
        name: '/day/',
        component: () => import('D:/works/mango/kiosk-module/backoffice/src/features/day/routes/index.vue'),
        /* no children */
      },
      {
        path: 'exceptions',
        name: '/day/exceptions',
        component: () => import('D:/works/mango/kiosk-module/backoffice/src/features/day/routes/exceptions.vue'),
        /* no children */
      },
      {
        path: 'kiosks',
        name: '/day/kiosks',
        component: () => import('D:/works/mango/kiosk-module/backoffice/src/features/day/routes/kiosks.vue'),
        /* no children */
      },
      {
        path: 'operations',
        name: '/day/operations',
        component: () => import('D:/works/mango/kiosk-module/backoffice/src/features/day/routes/operations.vue'),
        /* no children */
      },
      {
        path: 'signoff',
        name: '/day/signoff',
        component: () => import('D:/works/mango/kiosk-module/backoffice/src/features/day/routes/signoff.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/kiosks',
    /* internal name: '/kiosks' */
    /* no component */
    children: [
      {
        path: '',
        name: '/kiosks/',
        component: () => import('D:/works/mango/kiosk-module/backoffice/src/features/kiosks/routes/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/kiosks/[id]',
        component: () => import('D:/works/mango/kiosk-module/backoffice/src/features/kiosks/routes/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/tenancy',
    /* internal name: '/tenancy' */
    /* no component */
    children: [
      {
        path: '',
        name: '/tenancy/',
        component: () => import('D:/works/mango/kiosk-module/backoffice/src/features/tenancy/routes/index.vue'),
        /* no children */
      },
      {
        path: 'staff',
        name: '/tenancy/staff',
        component: () => import('D:/works/mango/kiosk-module/backoffice/src/features/tenancy/routes/staff.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

